var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table',{ref:"tableRef",attrs:{"resource":_vm.resource,"columns":_vm.columns,"filters":_vm.filters}})}
var staticRenderFns = []

export { render, staticRenderFns }